<template>
  <div class="products-container">
    <app-navbar8 logoSrc="/logo_trans-1500h.png">
      <template v-slot:link1>
        <div class="products-fragment10">
          <span class="products-text10">#home</span>
        </div>
      </template>
      <template v-slot:link2>
        <div class="products-fragment11">
          <span class="products-text11">#products</span>
        </div>
      </template>
      <template v-slot:link3>
        <div class="products-fragment12">
          <span class="products-text12">#services</span>
        </div>
      </template>
      <template v-slot:link4>
        <div class="products-fragment13">
          <span class="products-text13">#contact</span>
        </div>
      </template>
      <template v-slot:page1>
        <div class="products-fragment14">
          <span class="products-text14">Home</span>
        </div>
      </template>
      <template v-slot:page2>
        <div class="products-fragment15">
          <span class="products-text15">Products</span>
        </div>
      </template>
      <template v-slot:page3>
        <div class="products-fragment16">
          <span class="products-text16">Services</span>
        </div>
      </template>
      <template v-slot:page4>
        <div class="products-fragment17">
          <span class="products-text17">Contact</span>
        </div>
      </template>
      <template v-slot:action1>
        <div class="products-fragment18">
          <span class="products-text18">Sign In</span>
        </div>
      </template>
      <template v-slot:action2>
        <div class="products-fragment19">
          <span class="products-text19">Create</span>
        </div>
      </template>
      <template v-slot:page1Description>
        <div class="products-fragment20">
          <span class="products-text20">Page One Description</span>
        </div>
      </template>
      <template v-slot:page2Description>
        <div class="products-fragment21">
          <span class="products-text21">Page Two Description</span>
        </div>
      </template>
      <template v-slot:page3Description>
        <div class="products-fragment22">
          <span class="products-text22">Page Three Description</span>
        </div>
      </template>
      <template v-slot:page4Description>
        <div class="products-fragment23">
          <span class="products-text23">Page Four Description</span>
        </div>
      </template>
    </app-navbar8>
    <features-prod-cats
      feature1ImageSrc="/anisehyssop-1400w.jpg"
      feature2ImageSrc="/spearmintcocoa-1400w.jpg"
      feature3ImageSrc="/juniper-1400w.jpg"
      feature5ImageSrc="/fresh-1400w.jpg"
    >
      <template v-slot:content1>
        <div class="products-fragment24">
          <span class="products-text24">
            All organic and hand crafted herbal products
          </span>
        </div>
      </template>
      <template v-slot:heading1>
        <div class="products-fragment25">
          <span class="products-text25">Wildwood Herbs Products</span>
        </div>
      </template>
      <template v-slot:feature1Title>
        <div class="products-fragment26">
          <span class="products-text26">Herbal Teas</span>
        </div>
      </template>
      <template v-slot:feature2Title>
        <div class="products-fragment27">
          <span class="products-text27">Body Butter</span>
        </div>
      </template>
      <template v-slot:feature3Title>
        <div class="products-fragment28">
          <span class="products-text28">Soaps</span>
        </div>
      </template>
      <template v-slot:feature4Title>
        <div class="products-fragment29">
          <span class="products-text29">Salves</span>
        </div>
      </template>
      <template v-slot:feature5Title>
        <div class="products-fragment30">
          <span class="products-text30">Air Spritz</span>
        </div>
      </template>
      <template v-slot:feature6Title>
        <div class="products-fragment31">
          <span class="products-text31">
            Face
            <span v-html="rawttmf"></span>
          </span>
        </div>
      </template>
      <template v-slot:feature1Description>
        <div class="products-fragment32">
          <span class="products-text32">
            Hand-blended, organic teas, locally grown and sustainably harvested to
            help restore balance to your mind, body, and spirit.
          </span>
        </div>
      </template>
      <template v-slot:feature2Description>
        <div class="products-fragment33">
          <span class="products-text33">
            A blend of organic oils and butters that melts on your skin leaving it
            feel soft and luxuriously nourished.
          </span>
        </div>
      </template>
      <template v-slot:feature3Description>
        <div class="products-fragment34">
          <span class="products-text34">
            <span>
              Cold press soaps made in small batches with organic ingredients,
              100% essential and herb infused oils.
              <span v-html="raw5bby"></span>
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature4Description>
        <div class="products-fragment35">
          <span class="products-text37">
            Discover a wide range of herbal infused oils and beeswax salves, each
            crafted to address specific skin concerns and promote overall skin
            health.
          </span>
        </div>
      </template>
      <template v-slot:feature5Description>
        <div class="products-fragment36">
          <span class="products-text38">
            All-natural air spritz, crafted with pure essential oils, witch hazel,
            and water, perfect for everyday use on furniture, body, yoga mats, and
            more.
          </span>
        </div>
      </template>
      <template v-slot:feature6Description>
        <div class="products-fragment37">
          <span class="products-text39">
            Simple but effective face oil made with organic materials, no
            fragrance.
          </span>
        </div>
      </template>
    </features-prod-cats>
    <app-footer4 rootClassName="footer4root-class-name">
      <template v-slot:termsLink>
        <div class="products-fragment38">
          <span class="products-text40">Terms of Service</span>
        </div>
      </template>
      <template v-slot:cookiesLink>
        <div class="products-fragment39">
          <span class="products-text41">Cookies Settings</span>
        </div>
      </template>
      <template v-slot:privacyLink>
        <div class="products-fragment40">
          <span class="products-text42">Privacy Policy</span>
        </div>
      </template>
    </app-footer4>
  </div>
</template>

<script>
import AppNavbar8 from '../components/navbar8'
import FeaturesProdCats from '../components/features-prod-cats'
import AppFooter4 from '../components/footer4'

export default {
  name: 'Products',
  props: {},
  components: {
    AppNavbar8,
    FeaturesProdCats,
    AppFooter4,
  },
  data() {
    return {
      rawttmf: ' ',
      raw5bby: ' ',
    }
  },
  metaInfo: {
    title: 'Products - Wildwood Herbs',
    meta: [
      {
        property: 'og:title',
        content: 'Products - Wildwood Herbs',
      },
    ],
  },
}
</script>

<style scoped>
.products-container {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
 
.products-fragment10 {
  display: contents;
}
 
.products-text10 {
  display: inline-block;
}
 
.products-fragment11 {
  display: contents;
}
 
.products-text11 {
  display: inline-block;
}
 
.products-fragment12 {
  display: contents;
}
 
.products-text12 {
  display: inline-block;
}
 
.products-fragment13 {
  display: contents;
}
 
.products-text13 {
  display: inline-block;
}
 
.products-fragment14 {
  display: contents;
}
 
.products-text14 {
  display: inline-block;
}
 
.products-fragment15 {
  display: contents;
}
 
.products-text15 {
  display: inline-block;
}
 
.products-fragment16 {
  display: contents;
}
 
.products-text16 {
  display: inline-block;
}
 
.products-fragment17 {
  display: contents;
}
 
.products-text17 {
  display: inline-block;
}
 
.products-fragment18 {
  display: contents;
}
 
.products-text18 {
  display: inline-block;
}
 
.products-fragment19 {
  display: contents;
}
 
.products-text19 {
  display: inline-block;
}
 
.products-fragment20 {
  display: contents;
}
 
.products-text20 {
  display: inline-block;
}
 
.products-fragment21 {
  display: contents;
}
 
.products-text21 {
  display: inline-block;
}
 
.products-fragment22 {
  display: contents;
}
 
.products-text22 {
  display: inline-block;
}
 
.products-fragment23 {
  display: contents;
}
 
.products-text23 {
  display: inline-block;
}
 
.products-fragment24 {
  display: contents;
}
 
.products-text24 {
  display: inline-block;
}
 
.products-fragment25 {
  display: contents;
}
 
.products-text25 {
  display: inline-block;
}
 
.products-fragment26 {
  display: contents;
}
 
.products-text26 {
  display: inline-block;
}
 
.products-fragment27 {
  display: contents;
}
 
.products-text27 {
  display: inline-block;
}
 
.products-fragment28 {
  display: contents;
}
 
.products-text28 {
  display: inline-block;
}
 
.products-fragment29 {
  display: contents;
}
 
.products-text29 {
  display: inline-block;
}
 
.products-fragment30 {
  display: contents;
}
 
.products-text30 {
  display: inline-block;
}
 
.products-fragment31 {
  display: contents;
}
 
.products-text31 {
  display: inline-block;
}
 
.products-fragment32 {
  display: contents;
}
 
.products-text32 {
  display: inline-block;
}
 
.products-fragment33 {
  display: contents;
}
 
.products-text33 {
  display: inline-block;
}
 
.products-fragment34 {
  display: contents;
}
 
.products-text34 {
  display: inline-block;
}
 
.products-fragment35 {
  display: contents;
}
 
.products-text37 {
  display: inline-block;
}
 
.products-fragment36 {
  display: contents;
}
 
.products-text38 {
  display: inline-block;
}
 
.products-fragment37 {
  display: contents;
}
 
.products-text39 {
  display: inline-block;
}
 
.products-fragment38 {
  display: contents;
}
 
.products-text40 {
  display: inline-block;
}
 
.products-fragment39 {
  display: contents;
}
 
.products-text41 {
  display: inline-block;
}
 
.products-fragment40 {
  display: contents;
}
 
.products-text42 {
  display: inline-block;
}
</style>
